import { render } from "./Base.vue?vue&type=template&id=5f732ae3&bindings={\"group\":\"props\"}"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
script.render = render

export default script